export default __webpack_public_path__ + "static/media/landing-page-rephase.c184f70b.svg";